import React, { Fragment, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import toast from 'react-hot-toast'

import './Modal.scss'

import Button from 'Design/components/Button'
import PageHead, { PageHeading } from 'Layout/PageHead'
import PageHeadRight from 'Layout/PageHead/PageHeadRight'
import PageContent from 'Layout/PageContent'
import PageLoader from 'Layout/PageLoader'

import BotsList from './BotsList'
import CreateFlowModal from '../../../../containers/dashboard/CreateFlowModal'
import { useGetAllBotProfilesQuery } from 'Services/bot-profiles'
import FlowBuilder from './Flow'

import { useAddBotFlowMutation } from './bot-flows.service'
import parseErrorMessage from 'Utils/error-message-parser'

const BotsListContainer = () => {
  const [showAddBotModal, setShowAddBotModal] = useState(false)
  const [addBotFlow] = useAddBotFlowMutation()
  const { isLoading: isFetchingBotProfiles, data: botProfiles } = useGetAllBotProfilesQuery()

  const container = 'newDesign'
  const botId = botProfiles?.at(-1).id

  const handleAddNewBot = () => {
    setShowAddBotModal(true)
  }

  const hideAddFlowModal = () => {
    setShowAddBotModal(false)
  }

  const onAddBotFlow = (payload) => {
    const promise = addBotFlow(payload).unwrap()
    toast.promise(promise, {
      loading: 'Creating Bot',
      success: `Created '${payload.name}'`,
      error: parseErrorMessage('Error while creating bot. Try again...')
    })
  }

  if (isFetchingBotProfiles) {
    return <PageLoader />
  }

  return (
    <Fragment>
      <CreateFlowModal
        isOpen={showAddBotModal}
        hide={hideAddFlowModal}
        botId={botId}
        onAddBotFlow={onAddBotFlow}
        container={container}
      />
      <PageHead>
        <PageHeading>Bots</PageHeading>
        <PageHeadRight>
          <Button variant='primary' onClick={() => handleAddNewBot()}>
            New Bot
          </Button>
        </PageHeadRight>
      </PageHead>
      <PageContent>
        <BotsList botId={botId} container={container} />
      </PageContent>
    </Fragment>
  )
}

const Bots = () => {
  return (
    <Routes>
      <Route index element={<BotsListContainer />} />
      <Route path=':botId/flows/:flowId' element={<FlowBuilder />} />
    </Routes>
  )
}

export default Bots
